import { getAuthHeaders } from '../../../statistics/api/auth-headers';
import { SUPABASE_FUNCTIONS_URL } from '../../../statistics/api/config';

/**
 * Картинки публикаций для сборки документов.
 *
 * Общий файл, потому что картинки нужны всем отчётам: презентации — в
 * слайд, отчёту по услугам и посеву — в экран статистики, который потом
 * уезжает в Word и Excel.
 */

/**
 * Картинка сначала берётся напрямую. Обложки постов лежат на CDN Instagram
 * и обычно отдаются, но когда CDN отвечает без нужного заголовка, canvas
 * объявляет холст испорченным и файл собрать нельзя — тогда тот же адрес
 * идёт через прокси edge-функции, которой CORS не писан.
 */
export async function fetchImageBlob(url: string): Promise<Blob> {
  try {
    const res = await fetch(url);
    if (res.ok) return await res.blob();
  } catch {
    // CORS или сеть — пробуем через прокси
  }
  const headers = await getAuthHeaders();
  delete headers['Content-Type'];
  const res = await fetch(`${SUPABASE_FUNCTIONS_URL}/instagram/image-proxy?url=${encodeURIComponent(url)}`, {
    headers,
  });
  if (!res.ok) throw new Error(`image-proxy: ${res.status}`);
  return res.blob();
}
